import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {EmpresasService} from "../services/empresas.service";
import {PageChangeEvent} from "@progress/kendo-angular-grid";
import {CadUsuarioComponent} from "../cad-usuario/cad-usuario.component";
import {DialogRef, DialogService} from "@progress/kendo-angular-dialog";
import {
  TelaUsuarioPermissoesComponent
} from "../../compartilhado/tela-usuario-permissoes/tela-usuario-permissoes.component";
import {TelaGerenciarPapeisComponent} from "../../compartilhado/tela-gerenciar-papeis/tela-gerenciar-papeis.component";
import {KendoPopupUtils} from "../../lib/KendoPopupUtils";
import {AutorizacaoService} from "../../services/autorizacao.service";


@Component({
  selector: 'app-usuarios-empresa',
  templateUrl: './usuarios-empresa.component.html',
  styleUrls: ['./usuarios-empresa.component.scss']
})
export class UsuariosEmpresaComponent implements OnInit {
  @Input() public empresa: any;
  possuiModuloGarcom: boolean
  usuarios: any = [];
  usuariosFiltrados: any = [];
  filtroUsuario: string = '';
  paginacao = {
    size: 10,
    skip: 0,
    total: 0,
    buttonCount: 5,
    info: true,
    type: "numeric"  ,
    pageSizes: false,
    previousNext: true
  }
  loading: any;
  usuarioLogado: any = null;
  constructor(private empresaService: EmpresasService,
              private dialogService: DialogService,
              private autorizacao: AutorizacaoService) { }
  usuarioSelecionado: any = {};
  @ViewChild('drawer') drawerRef: any;

  ngOnInit() {
    this.carregueUsuarios();
    this.possuiModuloGarcom = this.empresa.modulos.some(modulo =>   modulo.nome ===  'garcom');

    this.autorizacao.usuarioLogado$.subscribe((usuario) => {
      if(!usuario) return;

      this.usuarioLogado = usuario;
      if(!this.usuarios.length) this.carregaDados();
    });
  }

  carregaDados() {
    this.carregueUsuarios();
  }

  private carregueUsuarios() {
    this.empresaService.listeUsuarios(this.empresa).then((usuarios: any) => {
      this.usuarios = usuarios;
      this.filtrarUsuarios();
    })
  }

  filtrarUsuarios() {
    if (!this.filtroUsuario || this.filtroUsuario.trim() === '') {
      this.usuariosFiltrados = [...this.usuarios];
    } else {
      const filtro = this.filtroUsuario.toLowerCase();
      this.usuariosFiltrados = this.usuarios.filter((usuario: any) => {
        return (
          (usuario.nome && usuario.nome.toLowerCase().includes(filtro)) ||
          (usuario.email && usuario.email.toLowerCase().includes(filtro)) ||
          (usuario.telefone && usuario.telefone.includes(filtro)) ||
          (usuario.numeroWhatsapp && usuario.numeroWhatsapp.whatsapp && usuario.numeroWhatsapp.whatsapp.includes(filtro))
        );
      });
    }
  }

  novoGarcom() {
    let novoUsuario = { garcom: true}

    const windowRef: DialogRef = this.dialogService.open({
      title: null,
      content: CadUsuarioComponent,
      minWidth: 250,
      width: window.innerWidth > 600 ? 600 : window.innerWidth,
      maxHeight: window.innerHeight - 100,
      cssClass: 'bsModal'
    });

    KendoPopupUtils.abriuPopupNgBootstrap(windowRef)

    windowRef.content.instance.setUsuario( this.empresa, novoUsuario);

    windowRef.result.subscribe( (result: any) => {
        if(result && result.id)
          Object.assign(novoUsuario, result)

        this.carregueUsuarios()
      },
      (a) => {
      });
  }

  novoUsuario() {
    let novoUsuario = { garcom: false, ativo: true}

    const windowRef: DialogRef = this.dialogService.open({
      title: null,
      content: CadUsuarioComponent,
      minWidth: 250,
      width: window.innerWidth > 600 ? 600 : window.innerWidth,
      maxHeight: window.innerHeight - 100,
      cssClass: 'bsModal'
    });

    KendoPopupUtils.abriuPopupNgBootstrap(windowRef)

    windowRef.content.instance.setUsuario( this.empresa, novoUsuario);

    windowRef.result.subscribe( (result: any) => {
        if(result && result.id)
          Object.assign(novoUsuario, result)

        this.carregueUsuarios()
      },
      (a) => {
      });
  }

  editarUsuario(event: any) {
    const dataItem = event.dataItem || event;

    const windowRef: DialogRef = this.dialogService.open({
      title: null,
      content: CadUsuarioComponent,
      minWidth: 250,
      width: window.innerWidth > 600 ? 600 : window.innerWidth,
      maxHeight: window.innerHeight - 100,
      cssClass: 'bsModal'
    });

    KendoPopupUtils.abriuPopupNgBootstrap(windowRef)

    windowRef.content.instance.setUsuario( this.empresa, dataItem);

    windowRef.result.subscribe( (result: any) => {
        if(result && result.id)
          Object.assign(dataItem, result)
      });
  }

  mudouPaginacao($event: PageChangeEvent) {
    console.log($event)
  }

  abraModalGerenciarPapeis(){
    let altura = window.innerHeight - 100;

    const windowRef = this.dialogService.open({
      title: String(`Papeis`),
      content: TelaGerenciarPapeisComponent,
      minWidth: 500,
      width: window.innerWidth > 800 ? 800 : window.innerWidth,
      maxHeight: altura
    });

    const tela: TelaGerenciarPapeisComponent = windowRef.content.instance;

    tela.windowRef = windowRef;
    tela.empresa = this.empresa;


    windowRef.result.subscribe((result: any) => {

    });
  }

  abraModalAssociarPapel(usuario: any) {
    let altura = window.innerHeight - 100;

    const windowRef = this.dialogService.open({
      title: String(`Papeis Usuário`),
      content: TelaUsuarioPermissoesComponent,
      minWidth: 500,
      width: window.innerWidth > 800 ? 800 : window.innerWidth,
      maxHeight: altura
    });

    const tela: TelaUsuarioPermissoesComponent = windowRef.content.instance;

    tela.windowRef = windowRef;
    tela.empresa = this.empresa;
    tela.usuario = usuario;

    windowRef.result.subscribe((result: any) => {  });
  }

  abrirPopupSessoes(dataItem: any) {
    this.usuarioSelecionado = dataItem;
    this.drawerRef.toggle();
  }

  removerUsuario(usuario: any) {
    // Verifica se o usuário é superadmin
    if (usuario.superadmin) {
      alert('Não é possível remover um usuário superadmin');
      return;
    }

    // Verifica se o usuário a ser removido é admin e se o usuário logado não é superadmin
    if (usuario.admin && (!this.usuarioLogado || !this.usuarioLogado.superadmin)) {
      alert('Apenas usuários superadmin podem remover usuários admin');
      return;
    }

    if (confirm(`Tem certeza que deseja remover o usuário2 ${usuario.nome}?`)) {
      this.loading = true;
      this.empresaService.removaUsuario(this.empresa, usuario).then((response: any) => {
        this.carregueUsuarios();
        this.loading = false;
      }).catch((error) => {
        console.error('Erro ao remover usuário:', error);
        this.loading = false;
      });
    }
  }
}
